import React, { useEffect, useState } from "react";
import { Table, Spinner, Alert, Input, Button, Form, FormGroup, Label } from "reactstrap";
import axiosInstance from "../../Request";
import { URL } from "../../api";

const PaymentsReporting = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [exporting, setExporting] = useState(false);
  const [error, setError] = useState("");

  // Filter States
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [paymentId, setPaymentId] = useState("");
  const [tranId, setTranId] = useState("");
  const [customerId, setCustomerId] = useState("");
  const [filterType, setFilterType] = useState("customerId");

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 30; 
  const [hasNextPage, setHasNextPage] = useState(false);
  const [activeFilters, setActiveFilters] = useState({});

  const [fintechList, setFintechList] = useState([]);
  const [selectedFintechId, setSelectedFintechId] = useState("");

  useEffect(() => {
    fetchPaymentSummary(1, {});
  }, []);

  useEffect(() => {
    const fetchFintechs = async () => {
        try {
            const res = await axiosInstance.get(URL.LSP_LIST);
            setFintechList((res.data || []).filter((f) => f.isActive));
        } catch (err) {
            console.error("Failed to fetch fintech list:", err);
        }
    };
    fetchFintechs();
}, []);

  const fetchPaymentSummary = async (page = 1, filters = {}) => {
    setLoading(true);
    setError("");
    try {
      const params = { ...filters };
      params.page = page - 1; // Backend zero-based
      params.size = rowsPerPage;

      const res = await axiosInstance.get(URL.REPORTING_PAYMENT_SUMMARY, { params });
      const resultData = Array.isArray(res.data) ? res.data : [];
      
      setData(resultData);
      setCurrentPage(page);
      setHasNextPage(resultData.length === rowsPerPage);
    } catch (err) {
      setError("Failed to fetch payment summary data.");
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (e) => {
    if (e) e.preventDefault();
    const filters = {};
    if (fromDate) filters.fromDate = fromDate;
    if (toDate) filters.toDate = toDate;
    
    if (filterType === "customerId" && customerId) filters.customerId = customerId;
    if (filterType === "paymentId" && paymentId) filters.paymentId = paymentId;
    if (filterType === "tranId" && tranId) filters.tranId = tranId;
    if (selectedFintechId) filters.fintechId = selectedFintechId;

    setActiveFilters(filters);
    fetchPaymentSummary(1, filters);
  };

  // SECURE AUTHENTICATED EXCEL EXPORT
  const handleExcelExport = async () => {
    if (data.length === 0) return alert("No data available to export!");

    setExporting(true);
    try {
      const params = { ...activeFilters, export: true };

      const response = await axiosInstance.get(URL.REPORTING_PAYMENT_SUMMARY, {
        params,
        responseType: 'blob', 
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `Payment_Report_${new Date().getTime()}.csv`);
      document.body.appendChild(link);
      link.click();
      
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (err) {
      alert("Export failed. Please check your session.");
    } finally {
      setExporting(false);
    }
  };

  const font10 = { fontSize: "10px" };
  const inputSmStyle = { fontSize: "11px", height: "30px", padding: "2px 6px" };
  const buttonSmStyle = { fontSize: "11px", padding: "4px 10px", height: "30px", lineHeight: "1" };

  return (
    <div style={font10}>
      <Form onSubmit={handleSearch} className="mb-3">
        <div className="d-flex align-items-end flex-wrap" style={{ gap: "10px" }}>
          <FormGroup className="mb-0">
            <Label className="mb-1 fw-bold">Filter Type</Label>
            <Input type="select" bsSize="sm" value={filterType} 
              onChange={(e) => {
                setFilterType(e.target.value);
                setPaymentId("");
                setCustomerId("");
                setTranId("");
              }} 
              style={inputSmStyle}
            >
              <option value="customerId">Customer ID</option>
              <option value="paymentId">Payment ID</option>
              <option value="tranId">Tran ID</option>
            </Input>
          </FormGroup>

          <FormGroup className="mb-0">
            <Label className="mb-1 fw-bold">
              {filterType === "customerId" ? "Customer ID" : filterType === "paymentId" ? "Payment ID" : "Tran ID"}
            </Label>
            <Input bsSize="sm" type={filterType === "customerId" ? "number" : "text"} 
              value={filterType === "customerId" ? customerId : filterType === "paymentId" ? paymentId : tranId} 
              onChange={(e) => {
                if (filterType === "customerId") setCustomerId(e.target.value);
                else if (filterType === "paymentId") setPaymentId(e.target.value);
                else setTranId(e.target.value);
              }} 
              style={inputSmStyle} 
            />
          </FormGroup>

          <FormGroup className="mb-0">
            <Label className="mb-1 fw-bold">From Date</Label>
            <Input type="date" bsSize="sm" value={fromDate} onChange={(e) => setFromDate(e.target.value)} style={inputSmStyle} />
          </FormGroup>

          <FormGroup className="mb-0">
            <Label className="mb-1 fw-bold">To Date</Label>
            <Input type="date" bsSize="sm" value={toDate} onChange={(e) => setToDate(e.target.value)} style={inputSmStyle} />
          </FormGroup>

          {/* 4. To Date FormGroup ke baad, Buttons se pehle ye dropdown add karo */}
<FormGroup className="mb-0">
    <Label className="mb-1 fw-bold">Fintech</Label>
    <Input
        type="select"
        bsSize="sm"
        value={selectedFintechId}
        onChange={(e) => setSelectedFintechId(e.target.value)}
        style={{ ...inputSmStyle, width: 160 }}
    >
        <option value="">All Fintechs</option>
        {fintechList.map((f) => (
            <option key={f.id} value={f.id}>
                {f.brandName || f.name}
            </option>
        ))}
    </Input>
</FormGroup>

          <div className="d-flex" style={{ gap: "6px" }}>
            <Button color="primary" type="submit" style={buttonSmStyle}>Search</Button>
            <Button color="success" onClick={handleExcelExport} style={buttonSmStyle} disabled={exporting}>
              {exporting ? <Spinner size="sm" /> : "Excel"}
            </Button>
          </div>
        </div>
      </Form>

      {loading ? (
        <div className="text-center p-4"><Spinner size="sm" /> Loading Payments...</div>
      ) : error ? (
        <Alert color="danger" style={font10}>{error}</Alert>
      ) : (
        <>
          <div style={{ overflowX: "auto" }}>
            <Table bordered striped hover responsive size="sm" className="mt-3 mb-0 text-nowrap">
              <thead className="thead-light">
                <tr>
                  <th>#</th>
                  <th>Payment ID</th>
                  <th>Cust ID</th>
                  <th>Loan Id</th>
                  <th>Borrower</th>
                  <th>Fintech Name</th>
                  <th>Tran Date</th>
                  <th>Tran ID</th>
                  <th>Total Payment</th>
                  <th>Extra Amt</th>
                  <th>Settled Amt</th>
                  <th>Settled Principal</th>
                  <th>Settled Interest</th>
                  <th>Settled Fees</th>
                  <th>Mobile Number</th>
                  <th>Pincode</th>
                  <th>State</th>
                </tr>
              </thead>
              <tbody>
                {data.length > 0 ? (
                  data.map((row, idx) => (
                    <tr key={idx}>
                      <td>{(currentPage - 1) * rowsPerPage + idx + 1}</td>
                      <td>{row.payment_id}</td>
                      <td>{row.customer_id}</td>
                      <td>{row.loan_id}</td>
                      <td>{row.borrower_name}</td>
                      <td className="fw-bold text-primary">{row.fintech_name || "N/A"}</td>
                      <td>{row.tran_date}</td>
                      <td>{row.tran_id}</td>
                      <td>₹{Number(row.total_payment_amount || 0).toLocaleString('en-IN', {minimumFractionDigits: 2})}</td>
                      <td>₹{Number(row.total_extra_amount || 0).toLocaleString('en-IN', {minimumFractionDigits: 2})}</td>
                      <td>₹{Number(row.total_settled_amount || 0).toLocaleString('en-IN', {minimumFractionDigits: 2})}</td>
                      <td>₹{Number(row.total_principal_settled || 0).toLocaleString('en-IN', {minimumFractionDigits: 2})}</td>
                      <td>₹{Number(row.total_interest_settled || 0).toLocaleString('en-IN', {minimumFractionDigits: 2})}</td>
                      <td>₹{Number(row.total_fees_settled || 0).toLocaleString('en-IN', {minimumFractionDigits: 2})}</td>
                      <td>{row.mobile_number}</td>
                      <td>{row.pin_code || "N/A"}</td>
                      <td>{row.state_name || "N/A"}</td>
                    </tr>
                  ))
                ) : (
                  <tr><td colSpan="15" className="text-center">No data found</td></tr>
                )}
              </tbody>
            </Table>
          </div>

          <div className="d-flex justify-content-center mt-3">
            <div className="d-flex align-items-center" style={{ gap: "5px" }}>
              <Button color="outline-primary" size="sm" style={buttonSmStyle} onClick={() => fetchPaymentSummary(currentPage - 1, activeFilters)} disabled={currentPage === 1}>Prev</Button>
              {Array.from({ length: hasNextPage ? currentPage + 1 : currentPage }, (_, i) => {
                const pageNum = i + 1;
                if (pageNum >= currentPage - 1 && pageNum <= currentPage + 1) {
                  return (
                    <Button key={pageNum} size="sm" style={buttonSmStyle} color={currentPage === pageNum ? "primary" : "outline-primary"} onClick={() => fetchPaymentSummary(pageNum, activeFilters)}>{pageNum}</Button>
                  );
                }
                return null;
              })}
              <Button color="outline-primary" size="sm" style={buttonSmStyle} onClick={() => fetchPaymentSummary(currentPage + 1, activeFilters)} disabled={!hasNextPage}>Next</Button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default PaymentsReporting;
